module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325705/particular01-b6c5f646c94ce399814b1449972ab885.png";